var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F2F2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_792_18322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.82071 15.0886L8.82071 15.0887C8.76429 16.3488 8.75 16.7455 8.75 20C8.75 23.2544 8.76428 23.6512 8.82071 24.916L8.82071 15.0886ZM8.82071 15.0886C8.87459 13.8808 9.0649 13.0907 9.32739 12.4127C9.60283 11.7141 9.95844 11.1324 10.5454 10.5454C11.1356 9.95527 11.7128 9.59723 12.4095 9.32861L12.4107 9.32815M8.82071 15.0886L12.4107 9.32815M12.4107 9.32815C13.0893 9.06521 13.8799 8.87463 15.0838 8.82071L12.4107 9.32815ZM20 8.75C16.7456 8.75 16.3488 8.76428 15.084 8.82071L20 8.75ZM20 8.75C23.253 8.75 23.652 8.76426 24.9224 8.81601M20 8.75L24.9224 8.81601M24.9224 8.81601C26.1293 8.86998 26.9191 9.06024 27.5968 9.32262C28.2954 9.59806 28.8771 9.95367 29.4641 10.5407L29.9827 10.0221L29.4641 10.5407C30.0543 11.1308 30.4123 11.708 30.6809 12.4048C30.9445 13.0892 31.1349 13.8803 31.1888 15.0838L24.9224 8.81601ZM31.2595 20C31.2595 16.7409 31.2453 16.3488 31.1888 15.084L31.2595 20ZM31.2595 20C31.2595 23.2592 31.2453 23.6512 31.1888 24.9162M31.2595 20L31.1888 24.9162M31.1888 24.9162C31.1349 26.1241 30.9446 26.9143 30.682 27.5923M31.1888 24.9162L30.682 27.5923M30.682 27.5923C30.4066 28.2908 30.051 28.8724 29.4641 29.4593C28.874 30.0495 28.2967 30.4075 27.6 30.6761M30.682 27.5923L27.6 30.6761M27.6 30.6761C26.9156 30.9397 26.1244 31.1302 24.9209 31.1841C24.9209 31.1841 24.9209 31.1841 24.9208 31.1841L24.9544 31.9333C23.6729 31.9905 23.268 32.0048 20.0048 32.0048C16.7416 32.0048 16.3366 31.9905 15.0552 31.9333C13.7737 31.8761 12.9019 31.6713 12.1397 31.3759M27.6 30.6761L8.62882 27.865C8.9337 28.6558 9.34816 29.3227 10.0151 29.9897C10.682 30.6566 11.3537 31.0663 12.1397 31.3759M12.1397 31.3759L12.4146 30.6781C12.4139 30.6779 12.4132 30.6776 12.4125 30.6773C12.4119 30.6771 12.4113 30.6768 12.4107 30.6766L12.1397 31.3759ZM9.32861 27.5952C9.06508 26.9108 8.87461 26.1197 8.82071 24.9162L9.32861 27.5952Z",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5859 20.0047C14.5859 17.0132 17.0128 14.5903 20.0003 14.5903C22.9922 14.5903 25.4146 17.0128 25.4146 20.0047C25.4146 22.9966 22.9922 25.419 20.0003 25.419C17.0084 25.419 14.5859 22.9966 14.5859 20.0047Z",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3461 13.5925C27.3461 14.1109 26.9258 14.5311 26.4074 14.5311C25.889 14.5311 25.4688 14.1109 25.4688 13.5925C25.4688 13.0741 25.889 12.6538 26.4074 12.6538C26.9258 12.6538 27.3461 13.0741 27.3461 13.5925Z",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_792_18322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram2);
export default __webpack_public_path__ + "static/media/instagram2.9049f348dfcc1dbca84fb61864fc110c.svg";
export { ForwardRef as ReactComponent };